import {
  GetAllTechnology,
  country,
} from '../../../types/Recruitment/CandidateList/CandidateListTypes'
import {
  OutgoingCandidateStatusEnum,
  DisplayedCandidateStatusEnum,
  CandidateCheckBoxFilterEnum,
  OutgoingCandidateSelectionStatusEnum,
  OutgoingStatusReportFilterOptions,
} from '../../../types/Recruitment/InterviewStatusReport/InterviewStatusReportTypes'

export const initialDate = ''
export const initialTechnology: GetAllTechnology = {
  id: -1,
  name: 'Select Technology',
}
export const initialCountry: country = {
  id: -1,
  name: 'Select Country',
  mobileCode: '',
  countryCode: '',
}

/* 
this is the key value pair for candidate status which are used to map value 
and displayed value in select option
the key value is the value that is sent with the api and value is the value displayed to user
*/
export const candidateStatusMapping: {
  [key in OutgoingCandidateStatusEnum]: DisplayedCandidateStatusEnum
} = {
  [OutgoingCandidateStatusEnum.all]: DisplayedCandidateStatusEnum.all,
  [OutgoingCandidateStatusEnum.offered]: DisplayedCandidateStatusEnum.offered,
  [OutgoingCandidateStatusEnum.offeredCancelled]:
    DisplayedCandidateStatusEnum.offeredCancelled,
  [OutgoingCandidateStatusEnum.rejected]: DisplayedCandidateStatusEnum.rejected,
  [OutgoingCandidateStatusEnum.new]: DisplayedCandidateStatusEnum.new,
  [OutgoingCandidateStatusEnum.inProgress]:
    DisplayedCandidateStatusEnum.inProgress,
  [OutgoingCandidateStatusEnum.rescheduled]:
    DisplayedCandidateStatusEnum.rescheduled,
  [OutgoingCandidateStatusEnum.hold]: DisplayedCandidateStatusEnum.hold,
  [OutgoingCandidateStatusEnum.reprocess]:
    DisplayedCandidateStatusEnum.reprocess,
  [OutgoingCandidateStatusEnum.noShow]: DisplayedCandidateStatusEnum.noShow,
  [OutgoingCandidateStatusEnum.didNotJoin]:
    DisplayedCandidateStatusEnum.didNotJoin,

  [OutgoingCandidateStatusEnum.joined]: DisplayedCandidateStatusEnum.joined,
  [OutgoingCandidateStatusEnum.L1_SHORTLISTED]:
    DisplayedCandidateStatusEnum.L1_SHORTLISTED,
  [OutgoingCandidateStatusEnum.L2_SHORTLISTED]:
    DisplayedCandidateStatusEnum.L2_SHORTLISTED,
  [OutgoingCandidateStatusEnum.L3_SHORTLISTED]:
    DisplayedCandidateStatusEnum.L3_SHORTLISTED,
  [OutgoingCandidateStatusEnum.L4_SHORTLISTED]:
    DisplayedCandidateStatusEnum.L4_SHORTLISTED,
  [OutgoingCandidateStatusEnum.L5_SHORTLISTED]:
    DisplayedCandidateStatusEnum.L5_SHORTLISTED,
  [OutgoingCandidateStatusEnum.L6_SHORTLISTED]:
    DisplayedCandidateStatusEnum.L6_SHORTLISTED,
}

// this is for the select date option in filters
export const candidateSelectionStatusList: OutgoingCandidateSelectionStatusEnum[] =
  [
    OutgoingCandidateSelectionStatusEnum.today,
    OutgoingCandidateSelectionStatusEnum.yesterday,
    OutgoingCandidateSelectionStatusEnum.thisWeek,
    OutgoingCandidateSelectionStatusEnum.lastWeek,
    OutgoingCandidateSelectionStatusEnum.lastMonth,
    OutgoingCandidateSelectionStatusEnum.currentMonth,
    OutgoingCandidateSelectionStatusEnum.custom,
  ]

// list of the check boxes that are above the search text in filter options
export const candidateCheckBoxFilterList: CandidateCheckBoxFilterEnum[] = [
  CandidateCheckBoxFilterEnum.searchByExperience,
  CandidateCheckBoxFilterEnum.multipleSearch,
  CandidateCheckBoxFilterEnum.searchByRecruiterName,
  CandidateCheckBoxFilterEnum.searchBySourceName,
]

// returns true if any one of the checkboxes is checked
export const isOneOfTheCheckBoxChecked = (
  filterOptions: OutgoingStatusReportFilterOptions,
): boolean => {
  return (
    filterOptions.searchByExperience === true ||
    filterOptions.searchByMultipleFlag === true ||
    filterOptions.searchByRecruiterName === true ||
    filterOptions.searchBySourceName === true
  )
}

export const isDateNotFilledWithCustom = (
  filterOptions: OutgoingStatusReportFilterOptions,
): boolean => {
  return (
    filterOptions.selectionStatus ===
      OutgoingCandidateSelectionStatusEnum?.custom.toString() &&
    (filterOptions?.fromDate === null || filterOptions?.toDate === null)
  )
}

export const getStartIndexForPagination = (
  currentPage: number,
  pageSize: number,
): number => {
  return (currentPage - 1) * pageSize
}
const vendorRestrictedStatuses = [
  'JOINED',
  'OFFERED',
  'DID_NOT_JOIN',
  'OFFER_CANCELLED',
  'joined',
]
// the api candidate status is converted to displayed candidate status
export const getValueOfCandidateStatusMappings = (
  keyValue: string,
  isVendor: boolean,
): string => {
  if (!keyValue && keyValue !== '') return DisplayedCandidateStatusEnum.all
  if (isVendor && vendorRestrictedStatuses.includes(keyValue)) {
    return DisplayedCandidateStatusEnum.offered
  }

  // Normalize incoming key for robust lookup
  const normalizedKey = keyValue?.toString().trim()

  const filteredObj = Object.entries(candidateStatusMapping).find(
    ([key]) => key === normalizedKey,
  )
  if (filteredObj !== undefined) {
    return filteredObj[1]
  }

  // If no mapping found, return the backend value as-is so the table shows actual data
  return keyValue
}

// used in other components also...
export const exchangeMonthAndDayInDate = (date: string): string => {
  const [day, month, year] = date?.split('/')

  // Construct the date strings in the "mm/dd/yyyy" format
  return `${month}/${day}/${year}`
}

export const getInterviewStatusReportTestId = (value: string): string => {
  return `interviewStatusReport-${value}`
}

export const getCandStatusReportTestId = (value: string): string => {
  return `candidateStatusReport-${value}`
}
